import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CustomTooltip, IconComponent, icon } from "../../../../../../../../../common/components";
import styles from "./Row.module.css";
import {
	setClauseId,
	setIsHandleScroll,
	setIsPdfScrolling,
} from "../../../../../../../slice/project-document/project-document-slice";
import ReviewRedirectionChapName from "../../../../ChatRedirection/ReviewRedirectionChapName";
import { isSegFeatureEnabled, SegFlags } from "../../../../../../../../../common/providers";

const Row = ({ data, hasChildren, label, level, open, onOpen, onSelect }) => {
	const [hovered, setHovered] = useState(false);
	const clauseId = useSelector(({ srProjectDocument }) => srProjectDocument.clauseId);
	const documentId = useSelector(({ srDocument }) => srDocument.documentId);
	const isPdfScrolling = useSelector(({ srProjectDocument }) => srProjectDocument.isPdfScrolling);
	const isThereAnotherFilter = useSelector(({ srProjectDocument }) => srProjectDocument.isThereAnotherFilter);
	const isThereAnotherTransverseFilter = useSelector(
		({ srProjectDocument }) => srProjectDocument.isThereAnotherTransverseFilter
	);
	const dispatch = useDispatch();

	const handleSelect = (e) => {
		dispatch(setIsPdfScrolling(false));
		dispatch(setIsHandleScroll(true));
		e.preventDefault();
		e.stopPropagation();
		onSelect(data);
		dispatch(setClauseId(data.id));
		if (hasChildren) {
			onOpen(e);
		}
	};
	const handleMouseEnter = () => {
		setHovered(true);
	};
	const handleMouseLeave = () => {
		setHovered(false);
	};
	const type = (level === 0 && "file") || (level === 1 && "h1") || "h2";
	const CHEVRON_OFFSET = 16;
	const basePaddingLeft = (level === 1 && 24) || (level > 1 && 24 + (level - 1) * 32) || null;
	return (
		<div
			className={styles.container}
			data-is-child={level > 0}
			data-level={level}
			data-open={open}
			data-selected={data.id === documentId || (!isPdfScrolling && data.id === clauseId && level > 0)}
			data-testid="tocElement.btn"
			data-type={type}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			<div
				className={styles.content}
				data-has-children={hasChildren}
				role="presentation"
				style={
					basePaddingLeft !== null
						? { paddingLeft: hasChildren ? basePaddingLeft : basePaddingLeft + CHEVRON_OFFSET }
						: {}
				}
				onClick={handleSelect}
			>
				{hasChildren && (
					<span className={styles.chevron} role="presentation" onClick={onOpen}>
						<IconComponent
							className={styles.chevron__icon}
							icon={(open && icon.faChevronUp) || icon.faChevronDown}
							size="xs"
						/>
					</span>
				)}
				<CustomTooltip showWhenOverflow enterDelay={1000} enterNextDelay={1000} title={label}>
					<span className={styles.label}>{label}</span>
				</CustomTooltip>
				<span>
					{hovered && level > 0 && isSegFeatureEnabled(SegFlags.CHAT_PROJECT) && (
						<ReviewRedirectionChapName label={label} />
					)}
				</span>
				{(isThereAnotherFilter || isThereAnotherTransverseFilter) &&
					(data?.matchedContent > 0 || data?.nbInformation > 0) && (
						<span className={styles.count}>{data.matchedContent || data.nbInformation}</span>
					)}
			</div>
		</div>
	);
};
export default Row;
